import isPdfSafeImageFile from './pdf-safe-image-for-embedding';

export default function getBlockNoteImageUploadError(file: File) {
  const type = file.type;
  if (
    type !== '' &&
    type !== 'application/octet-stream' &&
    !type.startsWith('image/')
  ) {
    return 'Only images are supported.';
  }
  if (!isPdfSafeImageFile(file)) {
    return 'Use JPEG, PNG, or GIF for images in this text — other formats may not appear in the exported PDF. Please convert the file or choose a different image.';
  }
  return null;
}
